var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"mb__error",attrs:{"status":_vm.status}},[_vm._l((_vm.value),function(val,index){return [_c('li',{key:index},[_vm._v(_vm._s(val))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }